import { ROUTES_EMPLOYEE_OVERVIEWS, ROUTES_EMPLOYEES } from '@/app/data/route_constants';

const SIDEBAR_NOTIFICATIONS = 'notifications';

export const EMPLOYEE_PROJECT_ROUTE_FALLBACKS = Object.freeze({
  [ROUTES_EMPLOYEES.PROJECT_DECISION]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_ACTIVITY]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_DOCUMENTS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_INSTALLMENTS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_PROPOSALS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_REMINDERS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_TICKETS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_TICKETS_SHOW]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_TYPE_REDIRECT]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_INBOX]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_ISSUES]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPE_ISSUES]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPE_SHOW_TICKET]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPE_TICKETS]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPE_UNITS]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_DOCUMENTS]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_ISSUES]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_SHOW_TICKET]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_UNIT_TICKETS]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS_SHOW]: ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS,
  [ROUTES_EMPLOYEES.PROJECT_SURVEY_REDIRECT]: ROUTES_EMPLOYEES.PROJECT_SURVEY_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_SURVEY_SUMMARY]: ROUTES_EMPLOYEES.PROJECT_SURVEY_TYPES,
  [ROUTES_EMPLOYEES.PROJECT_TICKETS_EMAIL_CONVERSATIONS_SHOW]: ROUTES_EMPLOYEES.PROJECT_TICKETS_EMAIL_CONVERSATIONS,
  [ROUTES_EMPLOYEES.PROJECT_TICKETS_NEW]: ROUTES_EMPLOYEES.PROJECT_TICKETS,
  [ROUTES_EMPLOYEES.PROJECT_TICKETS_SHOW]: ROUTES_EMPLOYEES.PROJECT_TICKETS,
});

export const EMPLOYEE_OVERVIEW_TO_PROJECT_ROUTE_MAPPINGS = Object.freeze({
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_AFTERCARE]: ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_CONVERSATIONS]: ROUTES_EMPLOYEES.PROJECT_TICKETS,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DECISIONS]: ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DOCUMENTS]: ROUTES_EMPLOYEES.PROJECT_DOCUMENTS,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FAQS]: ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS]: ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_MILESTONES]: ROUTES_EMPLOYEES.PROJECT_MILESTONES,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_NEWS]: ROUTES_EMPLOYEES.PROJECT_ANNOUNCEMENTS,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_SURVEYS]: ROUTES_EMPLOYEES.PROJECT_SURVEY_TYPES,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_TASKS]: ROUTES_EMPLOYEES.PROJECT_TODO_LISTS,
  [ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_UNIT_MILESTONES]: ROUTES_EMPLOYEES.PROJECT_MILESTONES_UNITS,
  [ROUTES_EMPLOYEES.CLIENT_EMAIL_CONVERSATIONS]: ROUTES_EMPLOYEES.PROJECT_TICKETS_EMAIL_CONVERSATIONS,
  [ROUTES_EMPLOYEES.CLIENT_EMAIL_CONVERSATIONS_SHOW]: ROUTES_EMPLOYEES.PROJECT_TICKETS_EMAIL_CONVERSATIONS,
});

export const EMPLOYEE_PROJECT_SAFE_TABS = Object.freeze([
  ROUTES_EMPLOYEES.PROJECT_ANNOUNCEMENTS,
  ROUTES_EMPLOYEES.PROJECT_DOCUMENTS,
  ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_ACTIVITY,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_AFTERCARE,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_CONTACTS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_DECISIONS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_DOCUMENTS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INSTALLMENTS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_MILESTONES,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_SETTINGS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_SURVEYS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_TASKS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_TICKETS,
  ROUTES_EMPLOYEES.PROJECT_INFORMATION_SPACES,
  ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS,
  ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS_LIST,
  ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS_MATRIX,
  ROUTES_EMPLOYEES.PROJECT_INSTALLMENTS,
  ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES,
  ROUTES_EMPLOYEES.PROJECT_MILESTONES,
  ROUTES_EMPLOYEES.PROJECT_MILESTONES_UNITS,
  ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS,
  ROUTES_EMPLOYEES.PROJECT_SALES_UNITS,
  ROUTES_EMPLOYEES.PROJECT_SURVEY_TYPES,
  ROUTES_EMPLOYEES.PROJECT_TICKETS,
  ROUTES_EMPLOYEES.PROJECT_TICKETS_EMAIL_CONVERSATIONS,
  ROUTES_EMPLOYEES.PROJECT_TODO_LISTS,
]);

export const EMPLOYEE_PROJECT_TO_OVERVIEW_ROUTE_MAPPINGS = Object.freeze({
  [ROUTES_EMPLOYEES.PROJECT_ANNOUNCEMENTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_NEWS,
  [ROUTES_EMPLOYEES.PROJECT_DECISION_TYPES]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DECISIONS,
  [ROUTES_EMPLOYEES.PROJECT_DOCUMENTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DOCUMENTS,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_AFTERCARE]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_AFTERCARE,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_DECISIONS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DECISIONS,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_DOCUMENTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_DOCUMENTS,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INSTALLMENTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_MILESTONES]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_MILESTONES,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_SURVEYS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_SURVEYS,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_TASKS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_TASKS,
  [ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_TICKETS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_CONVERSATIONS,
  [ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS,
  [ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS_LIST]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS,
  [ROUTES_EMPLOYEES.PROJECT_INSTALLMENT_GROUPS_MATRIX]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS,
  [ROUTES_EMPLOYEES.PROJECT_INSTALLMENTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FINANCIALS,
  [ROUTES_EMPLOYEES.PROJECT_ISSUE_LIST_TYPES]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_AFTERCARE,
  [ROUTES_EMPLOYEES.PROJECT_MILESTONES]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_MILESTONES,
  [ROUTES_EMPLOYEES.PROJECT_MILESTONES_UNITS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_UNIT_MILESTONES,
  [ROUTES_EMPLOYEES.PROJECT_QUESTION_LISTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_FAQS,
  [ROUTES_EMPLOYEES.PROJECT_SURVEY_TYPES]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_SURVEYS,
  [ROUTES_EMPLOYEES.PROJECT_TICKETS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_CONVERSATIONS,
  [ROUTES_EMPLOYEES.PROJECT_TICKETS_EMAIL_CONVERSATIONS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_CONVERSATIONS,
  [ROUTES_EMPLOYEES.PROJECT_TODO_LISTS]: ROUTES_EMPLOYEE_OVERVIEWS.OVERVIEW_TASKS,
});

export const EMPLOYEE_OVERVIEW_ROUTES = Object.freeze(Object.values(ROUTES_EMPLOYEE_OVERVIEWS));

export function isEmployeeProjectInformationRoute(route_name) {
  return typeof route_name === 'string' && route_name.startsWith(ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS);
}

export function getEmployeeProjectRouteName(route) {
  const route_name = route?.name;

  if (EMPLOYEE_OVERVIEW_TO_PROJECT_ROUTE_MAPPINGS[route_name]) {
    return EMPLOYEE_OVERVIEW_TO_PROJECT_ROUTE_MAPPINGS[route_name];
  }

  if (!route?.params?.project_id) {
    return ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION;
  }

  if (EMPLOYEE_PROJECT_ROUTE_FALLBACKS[route_name]) {
    return EMPLOYEE_PROJECT_ROUTE_FALLBACKS[route_name];
  }

  if (EMPLOYEE_PROJECT_SAFE_TABS.includes(route_name)) {
    return route_name;
  }

  return ROUTES_EMPLOYEES.PROJECT_INFORMATION_LEVELS_INFORMATION;
}

export function getEmployeeOverviewRouteName(route_name, route_name_fallback) {
  if (EMPLOYEE_OVERVIEW_ROUTES.includes(route_name)) {
    return route_name;
  }

  const route_name_safe = EMPLOYEE_PROJECT_ROUTE_FALLBACKS[route_name] || route_name;

  return EMPLOYEE_PROJECT_TO_OVERVIEW_ROUTE_MAPPINGS[route_name_safe] || route_name_fallback;
}

export default SIDEBAR_NOTIFICATIONS;
